module.exports = "<div class=\"colors-wrapper\"><div class=\"color-item\" ng-repeat=\"color in colors\" ng-click=\"setColor(color)\" ng-style=\"{'background-color':color.color}\" ng-class=\"{'color-item_active': color.active}\"></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/modules_settings/colors/template.jade
// module id = 329
// module chunks = 0